var map = {
	"./slide_1.png": "+G49",
	"./slide_2.png": "QLu6",
	"./slide_3.png": "fGax",
	"./slide_4.png": "Sq8x",
	"./slide_5.png": "AEC+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sm8Z";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates ^\.\/slide_.*\.png$
// module id = sm8Z
// module chunks = 0